import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TimerWorkerService {
  private worker: Worker | undefined;
  private timerSubjects: Map<string, Subject<void>> = new Map();

  constructor() {
    // Use a static URL since `import.meta` is not available in ES6
    const workerUrl = `${window.location.origin}/sotixsight/xs-timer.worker.js`;
    this.worker = new Worker(workerUrl);
    this.worker.onmessage = (event) => {
      const { id } = event.data;
      const subject = this.timerSubjects.get(id);
      if (subject) {
        subject.next();
      }
    };
  }

  start(id: string, interval: number): Observable<void> {
    const subject = new Subject<void>();
    this.timerSubjects.set(id, subject);

    this.worker?.postMessage({ action: 'start', id, interval });

    return subject.asObservable();
  }

  stop(id: string): void {
    if (this.timerSubjects.has(id)) {
      this.worker?.postMessage({ action: 'stop', id });
      this.timerSubjects.get(id)?.complete();
      this.timerSubjects.delete(id);
    }
  }
}
